import { useState } from "react";

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Meetupspagecity from "../Components/Meetupspagecity";
import Meetupspagelist from "../Components/Meetupspagelist";
import Meetupspagepastlist from "../Components/Meetupspagepastlist";
import MoMeetupspagelist from "../Components/MoMeetupspagelist";
import { API_BASE } from "../api/apiConfig";

const CommunityDtl = () => {

    const [activeTab, setActiveTab] = useState("past");

  const tabBtnClass = (tab) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all
     ${activeTab === tab
        ? "bg-background text-foreground shadow-sm"
        : "text-muted-foreground hover:text-foreground"
      }`;
  return (
    <>
      <Header />


<main className="min-h-screen bg-white">
  <div className="hidden sm:block">

    <section className="relative overflow-hidden bg-gradient-to-b from-primary/10 to-white ">
      {/* Background Decorative Elements */}
      <div className="absolute -top-24 left-0 right-0 h-64 w-full bg-primary/5 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/10 blur-3xl"></div>
      <div className="absolute left-1/4 top-1/3 h-32 w-32 rounded-full bg-secondary/20 blur-2xl"></div>
      {/* Main Content Container */}
      <div className="container mx-auto px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 md:gap-12 items-center">
          {/* Left Text Content */}
          <div className="reveal-on-scroll revealed">
            <div className="mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
              <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>
              Connect In Person
            </div>
            <h1 className="mb-4 text-3xl font-bold tracking-tight text-slate-800 md:text-5xl">
              Join Our <span className="text-gradient">Travel Meetups</span>
            </h1>
            <p className="mb-6 max-w-xl text-slate-600 md:text-lg">
              Connect with fellow travelers, explore new places, and create lasting memories. Our community-led meetups happen across India, bringing together travel enthusiasts for authentic local experiences.
            </p>
            <div className="flex flex-wrap gap-4">
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105">
                Find a Meetup
              </button>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 bg-white text-primary hover:bg-primary/10">
                Browse by City
              </button>
            </div>
            {/* Member Avatars & Stats */}
            <div className="mt-8 flex items-center gap-4">
              <div className="flex -space-x-3">
                <div
                  className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                  style={{
                    backgroundImage: "url('assets/images/member-1.jpg')",
                    backgroundSize: "cover"
                  }}
                ></div>
                <div
                  className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                  style={{
                    backgroundImage: "url('assets/images/member-2.jpg')",
                    backgroundSize: "cover"
                  }}
                ></div>
                <div
                  className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                  style={{
                    backgroundImage: "url('assets/images/member-3.jpg')",
                    backgroundSize: "cover"
                  }}
                ></div>
                <div
                  className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                  style={{
                    backgroundImage: "url('assets/images/member-4.jpg')",
                    backgroundSize: "cover"
                  }}
                ></div>
                <div
                  className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                  style={{
                    backgroundImage: "url('assets/images/member-5.jpg')",
                    backgroundSize: "cover"
                  }}
                ></div>
              </div>
              <div className="text-sm text-slate-600">
                <span className="font-medium text-primary">2,500+</span> travelers have joined meetups
              </div>
            </div>
          </div>
          {/* Right Image */}
          <div className="relative h-64 md:h-96 rounded-xl overflow-hidden shadow-xl reveal-on-scroll revealed">
            <img
              alt="Travel community meetup"
              loading="lazy"
              decoding="async"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/community-gathering.png"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4 text-white">
              <div className="flex items-center gap-2 mb-2">
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/80 text-white">
                  Popular
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/20 backdrop-blur-sm border-none text-white">
                  Delhi
                </div>
              </div>
              <h3 className="text-xl font-medium">Monthly Traveler's Mixer</h3>
              <p className="text-sm text-white/80">Last Saturday of every month</p>
            </div>
          </div>
        </div>
        {/* Stats Section */}
        <div className="mt-12 md:mt-16 grid grid-cols-2 gap-4 md:grid-cols-4 reveal-on-scroll revealed">
          {/* Stat Card 1 */}
          <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              {/* Map Icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
                <path d="M15 5.764v15" />
                <path d="M9 3.236v15" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-slate-800">25+ Cities</h3>
            <p className="text-sm text-slate-600">Across India</p>
          </div>
          {/* Stat Card 2 */}
          <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              {/* Calendar Icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
                <path d="M8 14h.01" />
                <path d="M12 14h.01" />
                <path d="M16 14h.01" />
                <path d="M8 18h.01" />
                <path d="M12 18h.01" />
                <path d="M16 18h.01" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-slate-800">120+</h3>
            <p className="text-sm text-slate-600">Monthly Meetups</p>
          </div>
          {/* Stat Card 3 */}
          <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              {/* User Icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-slate-800">15,000+</h3>
            <p className="text-sm text-slate-600">Community Members</p>
          </div>
          {/* Stat Card 4 */}
          <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              {/* Star Icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-slate-800">4.8/5</h3>
            <p className="text-sm text-slate-600">Average Rating</p>
          </div>
        </div>
      </div>
      {/* Bottom Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-white"></div>
    </section>

    

    <Meetupspagecity />



    <Meetupspagelist />


    <section className="bg-slate-50 py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
            Explore Our <span className="text-gradient">Meetup Community</span>
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-slate-600">
            Discover past events, read testimonials, and learn how to host your own meetups
          </p>
        </div>

        {/* Tabs */}
        <div className="w-full">
          <div className="mx-auto mb-8 grid h-10 max-w-md grid-cols-3 rounded-md bg-muted p-1">

            <button
              onClick={() => setActiveTab("past")}
              className={tabBtnClass("past")}
            >
              Past Meetups
            </button>

            <button
              onClick={() => setActiveTab("host")}
              className={tabBtnClass("host")}
            >
              Become a Host
            </button>

            <button
              onClick={() => setActiveTab("faq")}
              className={tabBtnClass("faq")}
            >
              FAQs
            </button>

          </div>

          {/* Past Meetups */}
          {activeTab === "past" && (
            <div className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-6"
              style={{ animationDuration: "0s" }}>
              
                <Meetupspagepastlist />
                
              {/*<div className="text-center">
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                  View All Past Meetups
                </button>
              </div>*/}
            </div>

          )}

          {/* Become a Host */}
          {activeTab === "host" && (
            <div
              className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-8"
            >
              <div className="grid gap-8 md:grid-cols-2">
                <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                  <h3 className="mb-4 text-xl font-bold text-slate-800">
                    Why Host a Meetup?
                  </h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 rounded-full bg-primary/20 p-1 text-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check h-4 w-4"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-slate-800">
                          Share Your Local Knowledge
                        </p>
                        <p className="text-sm text-slate-600">
                          Help travelers discover hidden gems and authentic experiences in
                          your city.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 rounded-full bg-primary/20 p-1 text-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check h-4 w-4"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-slate-800">Build Your Network</p>
                        <p className="text-sm text-slate-600">
                          Connect with like-minded travelers from around the world and
                          expand your circle.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 rounded-full bg-primary/20 p-1 text-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check h-4 w-4"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-slate-800">Earn Host Rewards</p>
                        <p className="text-sm text-slate-600">
                          Get exclusive perks, community recognition, and potential income
                          opportunities.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 rounded-full bg-primary/20 p-1 text-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check h-4 w-4"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-slate-800">Rediscover Your City</p>
                        <p className="text-sm text-slate-600">
                          See familiar places through new eyes and fall in love with your
                          hometown again.
                        </p>
                      </div>
                    </div>
                  </div>
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 mt-6 bg-primary text-white hover:bg-primary/90">
                    Apply to Host
                  </button>
                </div>
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-slate-800">Host Testimonials</h3>
                  <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="flex items-start gap-4">
                      <div
                        className="h-12 w-12 rounded-full ring-2 ring-primary/20"
                        style={{
                          backgroundImage: 'url("/host-avatar.jpg")',
                          backgroundSize: "cover"
                        }}
                      />
                      <div>
                        <div className="flex items-center gap-2">
                          <h4 className="font-medium text-slate-800">Deepak L.</h4>
                          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20">
                            Host
                          </div>
                        </div>
                        <p className="text-sm text-slate-600">Mumbai</p>
                        <p className="mt-2 text-sm italic text-slate-700">
                          "Hosting changed everything for me. I've made lifelong friends and
                          rediscovered my own city through the eyes of travelers."
                        </p>
                        <div className="mt-2 flex items-center gap-4 text-xs text-slate-500">
                          <span>Hosting Since 2022</span>
                          <span>28 meetups organized</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="flex items-start gap-4">
                      <div
                        className="h-12 w-12 rounded-full ring-2 ring-primary/20"
                        style={{
                          backgroundImage: 'url("assets/images/member-1.png")',
                          backgroundSize: "cover",minWidth: '48px',
                        }}
                      />
                      <div>
                        <div className="flex items-center gap-2">
                          <h4 className="font-medium text-slate-800">Anjali P.</h4>
                          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20">
                            Host
                          </div>
                        </div>
                        <p className="text-sm text-slate-600">Bangalore</p>
                        <p className="mt-2 text-sm italic text-slate-700">
                          "From a shy traveler to a confident host, this community has
                          transformed me. I love sharing my local insights!"
                        </p>
                        <div className="mt-2 flex items-center gap-4 text-xs text-slate-500">
                          <span>Hosting Since 2023</span>
                          <span>15 meetups organized</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                <h3 className="mb-4 text-xl font-bold text-slate-800">
                  How to Host a Successful Meetup
                </h3>
                <div className="grid gap-4 md:grid-cols-3">
                  <div className="rounded-lg bg-slate-50 p-4">
                    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary">
                      <span className="text-lg font-bold">1</span>
                    </div>
                    <h4 className="mb-2 font-medium text-slate-800">
                      Choose Your Activity
                    </h4>
                    <p className="text-sm text-slate-600">
                      Pick something you're passionate about that showcases your local area.
                      It could be a food tour, heritage walk, or outdoor adventure.
                    </p>
                  </div>
                  <div className="rounded-lg bg-slate-50 p-4">
                    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary">
                      <span className="text-lg font-bold">2</span>
                    </div>
                    <h4 className="mb-2 font-medium text-slate-800">Plan the Details</h4>
                    <p className="text-sm text-slate-600">
                      Set a date, time, meeting point, and capacity. Create a clear
                      itinerary and prepare any necessary resources.
                    </p>
                  </div>
                  <div className="rounded-lg bg-slate-50 p-4">
                    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary">
                      <span className="text-lg font-bold">3</span>
                    </div>
                    <h4 className="mb-2 font-medium text-slate-800">Submit for Approval</h4>
                    <p className="text-sm text-slate-600">
                      Fill out our host application with your meetup details. Our team will
                      review and provide feedback within 48 hours.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          )}

          {/* FAQs */}
          {activeTab === "faq" && (
            <div className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-6"
            >
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                Frequently Asked Questions
              </h3>
              <div className="space-y-4">
                <div className="rounded-lg border border-slate-200 p-4">
                  <h4 className="mb-2 font-medium text-slate-800">
                    How do I join a meetup?
                  </h4>
                  <p className="text-sm text-slate-600">
                    Simply browse the available meetups, click on one you're interested
                    in, and select "Join Meetup." You'll receive a confirmation email with
                    all the details.
                  </p>
                </div>
                <div className="rounded-lg border border-slate-200 p-4">
                  <h4 className="mb-2 font-medium text-slate-800">
                    Are meetups free to join?
                  </h4>
                  <p className="text-sm text-slate-600">
                    Most community meetups are free, though some special activities may
                    have a nominal fee to cover costs. Any fees will be clearly displayed
                    on the meetup page.
                  </p>
                </div>
                <div className="rounded-lg border border-slate-200 p-4">
                  <h4 className="mb-2 font-medium text-slate-800">
                    Can I cancel my RSVP?
                  </h4>
                  <p className="text-sm text-slate-600">
                    Yes, you can cancel up to 24 hours before the meetup. Please do so if
                    you can't attend so others can join. Repeated no-shows may affect your
                    ability to join future meetups.
                  </p>
                </div>
                <div className="rounded-lg border border-slate-200 p-4">
                  <h4 className="mb-2 font-medium text-slate-800">
                    How do I become a host?
                  </h4>
                  <p className="text-sm text-slate-600">
                    Click on "Apply to Host" and fill out our application form. We look
                    for hosts who are knowledgeable about their local area and passionate
                    about creating meaningful experiences.
                  </p>
                </div>
                <div className="rounded-lg border border-slate-200 p-4">
                  <h4 className="mb-2 font-medium text-slate-800">
                    Is there a mobile app for meetups?
                  </h4>
                  <p className="text-sm text-slate-600">
                    Yes, you can download our mobile app to discover, join, and manage
                    your meetups on the go. Available for both iOS and Android.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center">
              <p className="mb-4 text-slate-600">
                Still have questions about our meetups?
              </p>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90">
                Contact Support
              </button>
            </div>
          </div>

          )}

        </div>
      </div>
    </section>


    <section className="relative overflow-hidden bg-primary/5 py-12 md:py-16">
      {/* Background Decorative Elements */}
      <div className="absolute -top-24 right-0 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />
      <div className="absolute bottom-0 left-0 h-64 w-64 rounded-full bg-secondary/10 blur-3xl" />
      {/* Content Container */}
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center reveal-on-scroll revealed">
          <h2 className="mb-4 text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
            Ready to Connect with Fellow{" "}
            <span className="text-gradient">Travelers?</span>
          </h2>
          <p className="mb-8 text-slate-600 md:text-lg">
            Join our vibrant community of travel enthusiasts and start creating
            memories that last a lifetime. Whether you're looking to explore new
            places or share your local knowledge, there's a place for you in our
            community.
          </p>
          <div className="flex flex-col gap-4 sm:flex-row sm:justify-center">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105">
              Find a Meetup Near You
            </button>
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 bg-white text-primary hover:bg-primary/10">
              Learn More About Hosting
            </button>
          </div>
        </div>
      </div>
    </section>


  </div>



<div className="block sm:hidden pb-10 mb-10 ">
  <main className="min-h-screen bg-white">
    <div className="md:hidden">
      <div className="relative h-44 bg-gradient-to-br from-teal-500 to-cyan-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            alt="Travel Meetups"
            loading="lazy"
            decoding="async"
            data-nimg="fill"
            className="object-cover opacity-30"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              inset: 0,
              color: "transparent"
            }}
            src="/assets/images/community-gathering.jpg"
          />
        </div>
        <div className="relative h-full flex items-center justify-center text-white px-4">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-1">
              TRAVEL <span className="text-yellow-300">Meetups</span>
            </h1>
            <p className="text-sm text-white/90">
              Connect with fellow travelers in your city
            </p>
          </div>
        </div>
      </div>
      
      <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 px-4 py-6 border-b border-slate-100">
        <div className="text-center mb-5">
          <h2 className="text-xl font-bold text-slate-800 mb-2">
            Why Join Travel Meetups?
          </h2>
          <p className="text-sm text-slate-600">
            Experience the power of community travel
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center mb-3 mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-6 w-6 text-white"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3 className="font-semibold text-sm text-slate-800 text-center mb-1">
              Find Travel Buddies
            </h3>
            <p className="text-xs text-slate-600 text-center leading-relaxed">
              Connect with like-minded travelers
            </p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-3 mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-6 w-6 text-white"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
            </div>
            <h3 className="font-semibold text-sm text-slate-800 text-center mb-1">
              Explore Together
            </h3>
            <p className="text-xs text-slate-600 text-center leading-relaxed">
              Discover hidden gems in your city
            </p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center mb-3 mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-6 w-6 text-white"
              >
                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                <line x1={16} x2={16} y1={2} y2={6} />
                <line x1={8} x2={8} y1={2} y2={6} />
                <line x1={3} x2={21} y1={10} y2={10} />
              </svg>
            </div>
            <h3 className="font-semibold text-sm text-slate-800 text-center mb-1">
              Regular Events
            </h3>
            <p className="text-xs text-slate-600 text-center leading-relaxed">
              Weekly meetups across cities
            </p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center mb-3 mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-heart h-6 w-6 text-white"
              >
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
              </svg>
            </div>
            <h3 className="font-semibold text-sm text-slate-800 text-center mb-1">
              Build Friendships
            </h3>
            <p className="text-xs text-slate-600 text-center leading-relaxed">
              Create lasting connections
            </p>
          </div>
        </div>
      </div>

      
      

      <MoMeetupspagelist />



      <div className="bg-white px-4 py-6 mt-6 border-t border-slate-100">
        <h2 className="text-lg font-bold text-slate-800 mb-3">
          Meetup Moments
        </h2>
        <p className="text-sm text-slate-600 mb-4">
          See what happens at our meetups!
        </p>
        <div className="grid grid-cols-3 gap-2">
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 1"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-profile-1.png"
            />
          </div>
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 2"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-profile-1.png"
            />
          </div>
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 3"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-profile-1.png"
            />
          </div>
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 4"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-profile-1.png"
            />
          </div>
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 5"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-1.png"
            />
          </div>
          <div className="relative aspect-square rounded-lg overflow-hidden">
            <img
              alt="Meetup moment 6"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-profile-1.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="hidden md:block">
      <section className="relative overflow-hidden bg-gradient-to-b from-primary/10 to-white pt-24 md:pt-32">
        <div className="absolute -top-24 left-0 right-0 h-64 w-full bg-primary/5 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute left-1/4 top-1/3 h-32 w-32 rounded-full bg-secondary/20 blur-2xl" />
        <div className="container mx-auto px-4 md:px-6 md:py-16">
          <div className="grid gap-8 md:grid-cols-2 md:gap-12 items-center">
            <div className="reveal-on-scroll">
              <div className="mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
                <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
                Connect In Person
              </div>
              <h1 className="mb-4 text-3xl font-bold tracking-tight text-slate-800 md:text-5xl">
                Join Our <span className="text-gradient">Travel Meetups</span>
              </h1>
              <p className="mb-6 max-w-xl text-slate-600 md:text-lg">
                Connect with fellow travelers, explore new places, and create
                lasting memories. Our community-led meetups happen across India,
                bringing together travel enthusiasts for authentic local
                experiences.
              </p>
              <div className="flex flex-wrap gap-4">
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105">
                  Find a Meetup
                </button>
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 bg-white text-primary hover:bg-primary/10">
                  Browse by City
                </button>
              </div>
              <div className="mt-8 flex items-center gap-4">
                <div className="flex -space-x-3">
                  <div
                    className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-1.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div
                    className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-2.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div
                    className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-3.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div
                    className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-4.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div
                    className="h-10 w-10 rounded-full border-2 border-white ring-1 ring-primary/20 hover:z-10 hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-5.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                </div>
                <div className="text-sm text-slate-600">
                  <span className="font-medium text-primary">2,500+</span>{" "}
                  travelers have joined meetups
                </div>
              </div>
            </div>
            <div className="relative h-64 md:h-96 rounded-xl overflow-hidden shadow-xl reveal-on-scroll">
              <img
                alt="Travel community meetup"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent"
                }}
                src="/assets/images/community-gathering.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <div className="flex items-center gap-2 mb-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 bg-primary border-none">
                    Popular
                  </div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none">
                    Delhi
                  </div>
                </div>
                <h3 className="text-xl font-medium">
                  Monthly Traveler's Mixer
                </h3>
                <p className="text-sm text-white/80">
                  Last Saturday of every month
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 md:mt-16 grid grid-cols-2 gap-4 md:grid-cols-4 reveal-on-scroll">
            <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
              <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map h-6 w-6"
                >
                  <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
                  <line x1={9} x2={9} y1={3} y2={18} />
                  <line x1={15} x2={15} y1={6} y2={21} />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-slate-800">25+ Cities</h3>
              <p className="text-sm text-slate-600">Across India</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
              <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar-days h-6 w-6"
                >
                  <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                  <line x1={16} x2={16} y1={2} y2={6} />
                  <line x1={8} x2={8} y1={2} y2={6} />
                  <line x1={3} x2={21} y1={10} y2={10} />
                  <path d="M8 14h.01" />
                  <path d="M12 14h.01" />
                  <path d="M16 14h.01" />
                  <path d="M8 18h.01" />
                  <path d="M12 18h.01" />
                  <path d="M16 18h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-slate-800">120+</h3>
              <p className="text-sm text-slate-600">Monthly Meetups</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
              <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-user h-6 w-6"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx={12} cy={7} r={4} />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-slate-800">15,000+</h3>
              <p className="text-sm text-slate-600">Community Members</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-4 text-center shadow-sm">
              <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-6 w-6"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-slate-800">4.8/5</h3>
              <p className="text-sm text-slate-600">Average Rating</p>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-white" />
      </section>
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="mb-8 text-center reveal-on-scroll">
            <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
              Explore Meetups by <span className="text-gradient">City</span>
            </h2>
            <p className="mt-2 text-slate-600 max-w-2xl mx-auto">
              Discover travel meetups happening in these popular destinations
              across India
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 reveal-on-scroll">
            <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
              <div className="relative h-40 md:h-48">
                <img
                  alt="Mumbai"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/new-york-premium.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Mumbai</h3>
                <p className="text-sm text-white/80 mb-2">
                  Explore the city of dreams
                </p>
                <div className="flex items-center gap-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                    15 meetups
                  </div>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
              <div className="relative h-40 md:h-48">
                <img
                  alt="Delhi"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/london-premium.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Delhi</h3>
                <p className="text-sm text-white/80 mb-2">
                  Discover the heart of India
                </p>
                <div className="flex items-center gap-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                    12 meetups
                  </div>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
              <div className="relative h-40 md:h-48">
                <img
                  alt="Goa"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/barcelona-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Goa</h3>
                <p className="text-sm text-white/80 mb-2">
                  Beach vibes &amp; coastal adventures
                </p>
                <div className="flex items-center gap-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                    8 meetups
                  </div>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
              <div className="relative h-40 md:h-48">
                <img
                  alt="Jaipur"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/hawa-mahal-facade.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Jaipur</h3>
                <p className="text-sm text-white/80 mb-2">
                  Experience the Pink City
                </p>
                <div className="flex items-center gap-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                    6 meetups
                  </div>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
              <div className="relative h-40 md:h-48">
                <img
                  alt="Varanasi"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/sydney-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Varanasi</h3>
                <p className="text-sm text-white/80 mb-2">
                  Spiritual journeys along the Ganges
                </p>
                <div className="flex items-center gap-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                    5 meetups
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="meetups-section" className="py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6">
          <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between reveal-on-scroll">
            <div>
              <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
                Upcoming <span className="text-gradient">Meetups</span>
              </h2>
              <p className="text-slate-600">
                Find and join travel meetups happening near you
              </p>
            </div>
            <div className="flex flex-col gap-4 md:flex-row">
              <div className="relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-search absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                >
                  <circle cx={11} cy={11} r={8} />
                  <path d="m21 21-4.3-4.3" />
                </svg>
                <input
                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-10 border-slate-200"
                  placeholder="Search meetups..."
                  type="text"
                  defaultValue=""
                />
              </div>
              <div className="flex gap-2">
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-primary/90 h-10 px-4 py-2 bg-primary text-white">
                  All Meetups
                </button>
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary">
                  By City
                </button>
              </div>
            </div>
          </div>
          <div className="mb-8 flex flex-wrap gap-2 reveal-on-scroll">
            <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-filter h-4 w-4 text-primary"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
              </svg>
              <span className="text-slate-600">Filters:</span>
            </div>
            <div className="relative">
              <select className="appearance-none rounded-lg border border-slate-200 bg-white px-3 py-1.5 pr-8 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-primary/30">
                <option value="All">All</option>
                <option value="Adventure">Adventure</option>
                <option value="Cultural">Cultural</option>
                <option value="Food">Food</option>
                <option value="Nature">Nature</option>
                <option value="Photography">Photography</option>
                <option value="Spiritual">Spiritual</option>
                <option value="Community">Community</option>
                <option value="Hiking">Hiking</option>
                <option value="Wellness">Wellness</option>
                <option value="Art">Art</option>
                <option value="Cycling">Cycling</option>
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </div>
            <div className="relative">
              <select className="appearance-none rounded-lg border border-slate-200 bg-white px-3 py-1.5 pr-8 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-primary/30">
                <option value="All">All</option>
                <option value="Coorg">Coorg</option>
                <option value="Delhi">Delhi</option>
                <option value="Goa">Goa</option>
                <option value="Jaipur">Jaipur</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Munnar">Munnar</option>
                <option value="Rishikesh">Rishikesh</option>
                <option value="Varanasi">Varanasi</option>
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </div>
          </div>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "0ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Rishikesh River Rafting"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/tokyo-sakura-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Rishikesh
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Adventure
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-3.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Amit T.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Rishikesh River Rafting
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Experience the thrill of white water rafting on the sacred
                  Ganges River. Perfect for beginners and experienced rafters
                  alike. We'll navigate through exciting rapids while enjoying
                  the beautiful Himalayan scenery.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">April 5, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">2:00 PM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Laxman Jhula, Rishikesh
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">24</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">42</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m1">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "50ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Mumbai Heritage Walk"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/nyc-rooftop-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Mumbai
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Cultural
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-1.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Riya R.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Mumbai Heritage Walk
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Discover the rich colonial history and architectural marvels
                  of South Mumbai. We'll explore iconic landmarks like CSMT,
                  Gateway of India, and the charming lanes of Colaba, learning
                  about the city's fascinating past.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">May 12, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">6:30 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      CSMT, Mumbai
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">38</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">67</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m2">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "100ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Coorg Coffee Plantation Tour"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/london-pub-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Coorg
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Nature
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-2.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Deepa W.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Coorg Coffee Plantation Tour
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Immerse yourself in the lush coffee estates of Coorg. Learn
                  about sustainable coffee cultivation, participate in bean
                  picking, and enjoy a farm-to-cup tasting experience in the
                  misty Western Ghats.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">June 3, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">7:00 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Madikeri, Coorg
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">42</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">53</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m3">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "150ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Goa Beach Cleanup & BBQ"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/barcelona-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Goa
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Community
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-4.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Rohan M.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Goa Beach Cleanup &amp; BBQ
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Join us for a meaningful evening as we clean up beautiful
                  Anjuna Beach, followed by a sunset BBQ and music jam. Make new
                  friends while making a positive impact on the environment.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">June 15, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">4:00 PM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Anjuna Beach, Goa
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">28</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">39</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m4">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "200ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Varanasi Sunrise Boat Ride"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/sydney-event.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Varanasi
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Spiritual
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-5.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Aditya A.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Varanasi Sunrise Boat Ride
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Experience the magical sunrise over the Ganges River with a
                  traditional boat ride along Varanasi's ghats. Witness the
                  ancient morning rituals and immerse yourself in the spiritual
                  atmosphere of India's oldest living city.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">July 8, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">5:00 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Assi Ghat, Varanasi
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">35</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">48</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m5">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "250ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Delhi Food Trail"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/chandni-chowk-bustle.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Delhi
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Food
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-4.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Vikram S.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Delhi Food Trail
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Embark on a culinary adventure through Old Delhi's famous food
                  streets. Sample legendary street food from century-old
                  establishments, from parathas and kebabs to jalebi and kulfi.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">May 25, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">6:00 PM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Chandni Chowk, Delhi
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">32</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">58</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m6">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "300ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Jaipur Photography Walk"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/hawa-mahal-facade.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Jaipur
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Photography
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-2.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Priya K.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Jaipur Photography Walk
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Capture the Pink City's iconic architecture during the golden
                  morning light. Perfect for photography enthusiasts of all
                  levels. Our expert guide will help you find the best angles
                  and shots.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">June 22, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">7:30 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Hawa Mahal, Jaipur
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">22</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">36</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m7">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "350ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Munnar Tea Estate Hike"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/kerala-houseboat-serenity.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Munnar
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Hiking
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-3.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Thomas J.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Munnar Tea Estate Hike
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Trek through the emerald tea plantations of Munnar, learning
                  about tea cultivation and processing. Enjoy breathtaking views
                  of the Western Ghats and spot unique flora and fauna along the
                  way.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">July 15, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">8:00 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Munnar Town Center, Kerala
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">26</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">41</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m8">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "400ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Mumbai Street Art Tour"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/member-profile-3.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Mumbai
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Art
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-5.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Sanjay R.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Mumbai Street Art Tour
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Explore the vibrant street art scene of Bandra, Mumbai's
                  hippest neighborhood. Discover colorful murals, graffiti, and
                  installations by local and international artists that tell
                  stories of the city's culture and history.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">May 18, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">4:00 PM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      Bandra, Mumbai
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">18</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">29</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m9">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll"
              style={{ transitionDelay: "450ms" }}
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  alt="Delhi Historical Monuments Cycle Tour"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="/assets/images/india-gate-memorial.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 border-none bg-primary/90 text-white hover:bg-primary">
                  Delhi
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 border-none bg-white/90 text-slate-800 hover:bg-white">
                  Cycling
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div
                    className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                    style={{
                      backgroundImage: 'url("/member-1.jpg")',
                      backgroundSize: "cover"
                    }}
                  />
                  <div>
                    <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                      Hosted by
                    </p>
                    <p className="text-sm font-medium text-white">Rahul M.</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                  Delhi Historical Monuments Cycle Tour
                </h3>
                <p className="mb-4 text-sm text-slate-600 line-clamp-2">
                  Cycle through Delhi's historical heart, visiting iconic
                  monuments like India Gate, Rashtrapati Bhavan, and Humayun's
                  Tomb. Beat the traffic and enjoy the city's heritage in the
                  cool morning air.
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span className="text-slate-600">June 5, 2024</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-4 w-4 text-primary"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="text-slate-600">7:00 AM</span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-primary"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-slate-600 truncate">
                      India Gate, Delhi
                    </span>
                  </div>
                  <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-4 w-4 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div className="flex items-center gap-1">
                      <span className="text-slate-800">15</span>
                      <span className="text-slate-600">attending</span>
                      <span className="mx-1 text-slate-400">•</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-3 w-3 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-slate-600">32</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 group-hover:bg-primary/5">
                <a className="w-full" href="/meetups/m10">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                    View Details
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center reveal-on-scroll">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
              Load More Meetups
            </button>
          </div>
        </div>
      </section>
      <section className="bg-slate-50 py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6">
          <div className="mb-8 text-center reveal-on-scroll">
            <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
              Explore Our{" "}
              <span className="text-gradient">Meetup Community</span>
            </h2>
            <p className="mx-auto mt-2 max-w-2xl text-slate-600">
              Discover past events, read testimonials, and learn how to host
              your own meetups
            </p>
          </div>
          <div
            dir="ltr"
            data-orientation="horizontal"
            className="w-full reveal-on-scroll"
          >
            <div
              role="tablist"
              aria-orientation="horizontal"
              className="h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground mx-auto mb-8 grid w-full max-w-md grid-cols-3"
              tabIndex={0}
              data-orientation="horizontal"
              style={{ outline: "none" }}
            >
              <button
                type="button"
                role="tab"
                aria-selected="true"
                aria-controls="radix-«r42»-content-past"
                data-state="active"
                id="radix-«r42»-trigger-past"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm"
                tabIndex={-1}
                data-orientation="horizontal"
                data-radix-collection-item=""
              >
                Past Meetups
              </button>
              <button
                type="button"
                role="tab"
                aria-selected="false"
                aria-controls="radix-«r42»-content-host"
                data-state="inactive"
                id="radix-«r42»-trigger-host"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm"
                tabIndex={-1}
                data-orientation="horizontal"
                data-radix-collection-item=""
              >
                Become a Host
              </button>
              <button
                type="button"
                role="tab"
                aria-selected="false"
                aria-controls="radix-«r42»-content-faq"
                data-state="inactive"
                id="radix-«r42»-trigger-faq"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm"
                tabIndex={-1}
                data-orientation="horizontal"
                data-radix-collection-item=""
              >
                FAQs
              </button>
            </div>
            <div
              data-state="active"
              data-orientation="horizontal"
              role="tabpanel"
              aria-labelledby="radix-«r42»-trigger-past"
              id="radix-«r42»-content-past"
              tabIndex={0}
              className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-6"
              style={{ animationDuration: "0s" }}
            >
              <div className="grid gap-6 md:grid-cols-3">
                <div className="rounded-lg text-card-foreground overflow-hidden border border-slate-200 bg-white shadow-sm">
                  <div className="relative h-48 w-full">
                    <img
                      alt="Udaipur Sunset Boat Ride"
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src="/assets/images/riverside-rendezvous.png"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute right-3 top-3 bg-white/90 text-slate-800">
                      Udaipur
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute left-3 top-3 bg-primary/90 text-white">
                      Sightseeing
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="mb-2 text-lg font-medium text-slate-800">
                      Udaipur Sunset Boat Ride
                    </h3>
                    <div className="mb-4 space-y-2 text-sm">
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-calendar h-4 w-4 text-primary"
                        >
                          <rect
                            width={18}
                            height={18}
                            x={3}
                            y={4}
                            rx={2}
                            ry={2}
                          />
                          <line x1={16} x2={16} y1={2} y2={6} />
                          <line x1={8} x2={8} y1={2} y2={6} />
                          <line x1={3} x2={21} y1={10} y2={10} />
                        </svg>
                        <span className="text-slate-600">March 10, 2024</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4 text-primary"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span className="text-slate-600">
                          Lake Pichola, Udaipur
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-4 w-4 text-primary"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <span className="text-slate-600">32 attendees</span>
                      </div>
                    </div>
                    <div className="rounded-lg bg-slate-50 p-3">
                      <p className="mb-2 text-sm italic text-slate-600">
                        "Such a magical experience! The sunset views of the
                        palaces were breathtaking."
                      </p>
                      <p className="text-xs font-medium text-primary">
                        — Meera S.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg text-card-foreground overflow-hidden border border-slate-200 bg-white shadow-sm">
                  <div className="relative h-48 w-full">
                    <img
                      alt="Dharamshala Meditation Retreat"
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src="/assets/images/serene-asian-temple.png"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute right-3 top-3 bg-white/90 text-slate-800">
                      Dharamshala
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute left-3 top-3 bg-primary/90 text-white">
                      Wellness
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="mb-2 text-lg font-medium text-slate-800">
                      Dharamshala Meditation Retreat
                    </h3>
                    <div className="mb-4 space-y-2 text-sm">
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-calendar h-4 w-4 text-primary"
                        >
                          <rect
                            width={18}
                            height={18}
                            x={3}
                            y={4}
                            rx={2}
                            ry={2}
                          />
                          <line x1={16} x2={16} y1={2} y2={6} />
                          <line x1={8} x2={8} y1={2} y2={6} />
                          <line x1={3} x2={21} y1={10} y2={10} />
                        </svg>
                        <span className="text-slate-600">
                          February 25, 2024
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4 text-primary"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span className="text-slate-600">
                          McLeod Ganj, Dharamshala
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-4 w-4 text-primary"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <span className="text-slate-600">18 attendees</span>
                      </div>
                    </div>
                    <div className="rounded-lg bg-slate-50 p-3">
                      <p className="mb-2 text-sm italic text-slate-600">
                        "A truly transformative experience. Met amazing people
                        and learned so much."
                      </p>
                      <p className="text-xs font-medium text-primary">
                        — Rahul D.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg text-card-foreground overflow-hidden border border-slate-200 bg-white shadow-sm">
                  <div className="relative h-48 w-full">
                    <img
                      alt="Kolkata Literary Walk"
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src="/assets/images/story-japan.jpg"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute right-3 top-3 bg-white/90 text-slate-800">
                      Kolkata
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute left-3 top-3 bg-primary/90 text-white">
                      Cultural
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="mb-2 text-lg font-medium text-slate-800">
                      Kolkata Literary Walk
                    </h3>
                    <div className="mb-4 space-y-2 text-sm">
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-calendar h-4 w-4 text-primary"
                        >
                          <rect
                            width={18}
                            height={18}
                            x={3}
                            y={4}
                            rx={2}
                            ry={2}
                          />
                          <line x1={16} x2={16} y1={2} y2={6} />
                          <line x1={8} x2={8} y1={2} y2={6} />
                          <line x1={3} x2={21} y1={10} y2={10} />
                        </svg>
                        <span className="text-slate-600">January 15, 2024</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4 text-primary"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span className="text-slate-600">
                          College Street, Kolkata
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-4 w-4 text-primary"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <span className="text-slate-600">24 attendees</span>
                      </div>
                    </div>
                    <div className="rounded-lg bg-slate-50 p-3">
                      <p className="mb-2 text-sm italic text-slate-600">
                        "As a book lover, this was heaven! Our host knew all the
                        hidden bookshops."
                      </p>
                      <p className="text-xs font-medium text-primary">
                        — Ananya B.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                  View All Past Meetups
                </button>
              </div>
            </div>
            <div
              data-state="inactive"
              data-orientation="horizontal"
              role="tabpanel"
              aria-labelledby="radix-«r42»-trigger-host"
              hidden=""
              id="radix-«r42»-content-host"
              tabIndex={0}
              className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-8"
            />
            <div
              data-state="inactive"
              data-orientation="horizontal"
              role="tabpanel"
              aria-labelledby="radix-«r42»-trigger-faq"
              hidden=""
              id="radix-«r42»-content-faq"
              tabIndex={0}
              className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-6"
            />
          </div>
        </div>
      </section>
      <section className="relative overflow-hidden bg-primary/5 py-12 md:py-16">
        <div className="absolute -top-24 right-0 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-64 w-64 rounded-full bg-secondary/10 blur-3xl" />
        <div className="container mx-auto px-4 md:px-6">
          <div className="mx-auto max-w-3xl text-center reveal-on-scroll">
            <h2 className="mb-4 text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
              Ready to Connect with Fellow{" "}
              <span className="text-gradient">Travelers?</span>
            </h2>
            <p className="mb-8 text-slate-600 md:text-lg">
              Join our vibrant community of travel enthusiasts and start
              creating memories that last a lifetime. Whether you're looking to
              explore new places or share your local knowledge, there's a place
              for you in our community.
            </p>
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-center">
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105">
                Find a Meetup Near You
              </button>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 bg-white text-primary hover:bg-primary/10">
                Learn More About Hosting
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</div>


</main>



      <Footer />
    </>
  );
};

export default CommunityDtl;
